/// <reference types="vite/client" />
import { registerLocaleModules, type Messages } from '@fondationcss/sdk'

// Each area keeps its texts in `<area>/fr-CA.json` and `<area>/en-CA.json`; this registers them all.
// i18n-ignore-next-line: file-name glob pattern, not user-facing text
registerLocaleModules('fr-CA', import.meta.glob<Messages>('./**/fr-CA.json', { eager: true, import: 'default' }))
// i18n-ignore-next-line: file-name glob pattern, not user-facing text
registerLocaleModules('en-CA', import.meta.glob<Messages>('./**/en-CA.json', { eager: true, import: 'default' }))
